import { postApi } from "./api_instance";

export const sendSellerReply = async (formData, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/projects/api/communication/replay/seller",
      sendToken: true,
      data: formData,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
